import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/medical/MedicalPageClient.tsx");
